import { render, staticRenderFns } from "./BathChargeConfig.vue?vue&type=template&id=2578ab6e&scoped=true"
import script from "./BathChargeConfig.vue?vue&type=script&lang=js"
export * from "./BathChargeConfig.vue?vue&type=script&lang=js"
import style0 from "./BathChargeConfig.vue?vue&type=style&index=0&id=2578ab6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2578ab6e",
  null
  
)

export default component.exports